import type { MutableRefObject } from 'react';

import Header from '../landing-pages-v2/shared/header/Header';
import type { MegaNavItem, MenuLink } from '../landing-pages-v2/shared/types';

const mainNavLinks: MenuLink[] = [
  {
    name: 'Sell',
    href: '/cash-now-more-later',
  },
  {
    name: 'Buy',
    href: '/homes',
  },
  {
    name: 'Agents',
    href: '/agents',
  },
  {
    name: 'Mortgage',
    href: '/mortgage',
  },
];

const menuPanelNavLinks: MenuLink[] = [];

const megaNavData: MegaNavItem[] = mainNavLinks.map((link) => ({
  name: link.name,
  href: link.href,
}));

interface StaticSiteHeaderProps {
  slug: string;
  closeMenuRef?: MutableRefObject<() => void>;
  className?: string;
}

const ctaLink: MenuLink = {
  name: 'Get a cash offer',
  href: '/',
};

const StaticSiteHeader = ({ slug, closeMenuRef, className }: StaticSiteHeaderProps) => {
  return (
    <Header
      menuPanelNavLinks={menuPanelNavLinks}
      mainNavLinks={mainNavLinks}
      ctaTitle="Get started"
      ctaLink={ctaLink}
      slug={slug}
      megaNavData={megaNavData}
      closeMenuRef={closeMenuRef}
      className={className}
    />
  );
};

export default StaticSiteHeader;
